<template>
  <div>
      <hotel-order :orderId="orderId"/>
  </div>
</template>

<script>
  import HotelOrder from './HotelOrder/OrderIndex'
  export default {
    name: 'OrderDetail',
    components: {
      HotelOrder
    },
    props: {},
    data() {
      return {
      };
    },
    computed: {
      orderId () { return String(this.$route.query.orderId)},
    },
    watch: {},
    created() {},
    mounted() {},
    methods: {}
  };
</script>

<style lang="scss" scoped>
</style>
